export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    productName = "",
    fiscalYear = "",
    bookNumber = "",
    details = [],
    totalIncurred = { quantity: 0, amount: 0, taxAmount: 0, deductionAmount: 0 },
    netRevenue = 0,
    costOfGoodsSold = 0,
    grossProfit = 0,
    totalPages = "1",
    openingDate = "",
    reportDate = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let rowsHtml = "";
  details.forEach((item) => {
    rowsHtml += `
      <tr>
        <td class="border text-center">${item.bookingDate || ""}</td>
        <td class="border text-center">${item.documentNumber || ""}</td>
        <td class="border text-center">${item.documentDate || ""}</td>
        <td class="border px-1">${item.description || ""}</td>
        <td class="border text-center">${item.correspondingAccount || ""}</td>
        <td class="border text-right px-1">${fmt(item.quantity)}</td>
        <td class="border text-right px-1">${fmt(item.unitPrice)}</td>
        <td class="border text-right px-1 font-bold">${fmt(item.amount)}</td>
        <td class="border text-right px-1">${fmt(item.taxAmount)}</td>
        <td class="border text-right px-1">${fmt(item.deductionAmount)}</td>
      </tr>
    `;
  });

  // Total Incurred
  rowsHtml += `
    <tr style="font-weight: bold;">
      <td class="border"></td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border px-1">Cộng số phát sinh</td>
      <td class="border"></td>
      <td class="border text-right px-1">${fmt(totalIncurred.quantity)}</td>
      <td class="border"></td>
      <td class="border text-right px-1">${fmt(totalIncurred.amount)}</td>
      <td class="border text-right px-1">${fmt(totalIncurred.taxAmount)}</td>
      <td class="border text-right px-1">${fmt(totalIncurred.deductionAmount)}</td>
    </tr>
  `;

  // Financial Rows
  rowsHtml += `
    <tr style="font-weight: bold;">
      <td class="border" colspan="3"></td>
      <td class="border px-1" colspan="2">- Doanh thu thuần</td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border text-right px-1" style="color: blue;">${fmt(netRevenue)}</td>
      <td class="border"></td>
      <td class="border"></td>
    </tr>
    <tr style="font-weight: bold;">
      <td class="border" colspan="3"></td>
      <td class="border px-1" colspan="2">- Giá vốn hàng bán</td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border text-right px-1">${fmt(costOfGoodsSold)}</td>
      <td class="border"></td>
      <td class="border"></td>
    </tr>
    <tr style="font-weight: bold;" bgcolor="#FAFAFA">
      <td class="border" colspan="3"></td>
      <td class="border px-1" colspan="2">- Lãi gộp</td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border text-right px-1" style="color: green;">${fmt(grossProfit)}</td>
      <td class="border"></td>
      <td class="border"></td>
    </tr>
  `;

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 13px; color: black; line-height: 1.4;">
      <table width="100%">
        <tr>
          <td width="60%" valign="top">
            <div class="font-bold">Đơn vị: <span style="font-weight: normal; border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="font-weight: normal; border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="40%" align="center">
            <div class="font-bold">Mẫu số S35-DN</div>
            <div style="font-style: italic; font-size: 11px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 20px 0;">
        <h2 style="margin: 0; text-transform: uppercase;">SỔ CHI TIẾT BÁN HÀNG</h2>
        <div style="margin-top: 10px;">Tên sản phẩm: <span style="font-weight: bold; border-bottom: 1px dotted black; padding: 0 20px;">${productName}</span></div>
        <div style="margin-top: 5px;">Năm: <span style="font-weight: bold; border-bottom: 1px dotted black; padding: 0 10px;">${fiscalYear}</span></div>
        <div style="margin-top: 5px;">Quyển số: <span style="font-weight: bold; border-bottom: 1px dotted black; padding: 0 10px;">${bookNumber}</span></div>
      </div>

      <table width="100%" style="border-collapse: collapse; margin-top: 20px;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="70">Ngày, tháng ghi sổ</th>
            <th class="border" colspan="2">Chứng từ</th>
            <th class="border" rowspan="2">Diễn giải</th>
            <th class="border" rowspan="2" width="60">TK đối ứng</th>
            <th class="border" colspan="3">Doanh thu</th>
            <th class="border" colspan="2">Các khoản tính trừ</th>
          </tr>
          <tr>
            <th class="border" width="60">Số hiệu</th>
            <th class="border" width="60">Ngày tháng</th>
            <th class="border" width="60">Số lượng</th>
            <th class="border" width="100">Đơn giá</th>
            <th class="border" width="100">Thành tiền</th>
            <th class="border" width="100">Thuế</th>
            <th class="border" width="100">Giảm trừ</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            <th class="border">D</th>
            <th class="border">E</th>
            <th class="border">1</th>
            <th class="border">2</th>
            <th class="border">3</th>
            <th class="border">4</th>
            <th class="border">5</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
        </tbody>
      </table>

      <div style="margin-top: 25px;">
        <div style="margin-bottom: 5px;">- Sổ này có <span style="border-bottom: 1px dotted black; padding: 0 10px;">${totalPages}</span> trang, đánh số từ trang 01 đến trang...</div>
        <div>- Ngày mở sổ: <span style="border-bottom: 1px dotted black; padding: 0 10px;">${openingDate}</span></div>
      </div>

      <table width="100%" style="margin-top: 40px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 80px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 80px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 11px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 80px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>
    </div>

    <style>
      .border { border: 1px solid black; }
      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .font-bold { font-weight: bold; }
      .px-1 { padding: 0 4px; }
    </style>
  `;
};
